<template>
  <div class="vip-history-logs">
    <div class="c-page-header c-page-header--flush">
      <div>
        <h3 class="c-page-header__title">
          VIP history
        </h3>
        <p class="c-page-header__subtitle">
          Every change made to VIP pages and assets. Click a row to see what changed.
        </p>
      </div>
    </div>

    <history-log-table
      :logs="historyLogs"
      @open="handleOpen"
    />

    <paginate
      v-if="totalPages > 1"
      v-model="currentPage"
      :page-count="totalPages"
      :prev-text="'‹'"
      :next-text="'›'"
      :page-range="5"
      :margin-pages="1"
      :click-handler="handlePageChange"
      :container-class="'c-pagination'"
      :prev-link-class="'md-button prev md-elevation-1'"
      :next-link-class="'md-button next md-elevation-1'"
      :page-link-class="'md-button md-elevation-1'"
      :break-view-link-class="'md-button'"
      :active-class="'active'"
      :disabled-class="'disabled'"
    />
  </div>
</template>

<script>
import HistoryLogTable from '@/shared/history-log/HistoryLogTable.vue';
import HistoryLogModalComponent from '@/pages/on-line/help/sub-pages/help-history-logs/modals/HistoryLogModalComponent.vue';
import { historyLogsService } from "@/services/history-logs";
import { onlinePermissionsMixin } from "@/mixins/onlinePermissionsMixin";
import Paginate from 'vuejs-paginate';
import moment from 'moment';

export default {
  name: "VipHistoryLogsComponent",

  components: {
    HistoryLogTable,
    Paginate,
  },

  mixins: [onlinePermissionsMixin],

  data() {
    return {
      historyLogs: [],
      currentPage: 1,
      limit: 100,
      totalItems: 0,
    };
  },

  computed: {
    preparedHistoryLogs() {
      return this.formatLogsTableData(this.historyLogs);
    },

    totalPages() {
      return this.totalItems;
    },
  },

  methods: {
    async getHistoryLogs() {
      const response = await historyLogsService.getHistoryLogs({
        type: 'vip',
        page: this.currentPage,
        limit: this.limit,
      });

      this.historyLogs = response.data.items;
      this.totalItems = response.data.pageCount;
    },

    async handlePageChange(page) {
      this.currentPage = typeof page !== 'number' ? 1 : page;
      await this.getHistoryLogs();
    },

    async loadHistoryLogs() {
      await this.getHistoryLogs();
    },

    resetHistoryLogs() {
      this.historyLogs = [];
      this.currentPage = 1;
      this.totalItems = 0;
    },

    formatLogsTableData(logs) {
      return logs.map(log => ({
        historyLog: log,
        rowData: {
          'User': log.user?.email || 'Unknown',
          'Action': log.description?.message || 'N/A',
          'Date': moment(log.createdAt).format('DD/MM/YYYY HH:mm')
        }
      }));
    },

    handleOpen(historyLog) {
      this.$modal.show(
        HistoryLogModalComponent,
        { historyLog: historyLog },
        { height: "auto", width: 960, scrollable: true }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
// inside the VIP tab panel, which has no padding of its own
.vip-history-logs {
  padding: 20px 24px;
}
</style>
